<template>
  <div class="page-wrapper">
    <main class="main">
      <nav class="breadcrumb-nav">
        <div class="container">
          <ul class="breadcrumb bb-no">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>
              {{ $yuyanbao.sousuo }}
            </li>
          </ul>
        </div>
      </nav>

      <div class="page-content mb-10" v-loading="loading">
        <div class="container">
          <div class="main-content">
            <div
              class="shop-default-banner shop-boxed-banner banner d-flex align-items-center mb-6 br-xs"
              style="background-color: #ffc74e"
              :style="{
                backgroundImage: 'url(' + $shezhi.shoptupian + ')',
              }"
            >
              <div class="banner-content">
                <h3
                  class="banner-title text-white text-uppercase font-weight-bolder ls-10"
                >
                  {{ $yuyanbao.sousuo }}
                </h3>
              </div>
            </div>
            <div
              class="product-wrapper row cols-lg-4 cols-md-3 cols-sm-2 cols-2"
            >
              <div
                class="product-wrap"
                v-for="(item, index) in products"
                :key="index"
              >
                <div class="product text-center">
                  <figure class="product-media">
                    <router-link
                      :to="{ path: '/product', query: { ukey: item.ukey } }"
                    >
                      <img
                        :src="
                          item.tupian && item.tupian.length > 0
                            ? item.tupian[0]
                            : $tupianmoren
                        "
                        width="300"
                        height="338"
                      />
                    </router-link>
                  </figure>
                  <div class="product-details">
                    <h3 class="product-name">
                      <router-link
                        :to="{ path: '/product', query: { ukey: item.ukey } }"
                      >
                        {{ duoyuyan(item) }}
                      </router-link>
                    </h3>

                    <div class="product-pa-wrapper">
                      <div
                        class="product-price"
                        v-if="item.leixing === 1 || item.leixing === 3"
                      >
                        {{ (item.jiage / 100).toFixed(2) + $shezhi.huobi }}
                      </div>
                      <div class="product-price" v-if="item.leixing === 2">
                        {{ (min_jiage(item) / 100).toFixed(2) + $shezhi.huobi }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getShangPin } from "@/api/shangpin";

export default {
  name: "Search",
  components: {},
  watch: {
    $route(to, from) {
      if (to.query.search != from.query.search) {
        this.search = to.query.search;
        this.get_shangpin_http();
      }
    },
  },
  data() {
    return {
      loading: false,
      search: "",
      products: [],
      mode: "grid",
      show: 12,
      shows: [9, 12, 24, 36],
      page: 1,
      productsshow: [],
      mingcheng: "",
    };
  },
  mounted() {
    this.search = this.$route.query.search;
    this.get_shangpin_http();
  },

  methods: {
    get_shangpin_http() {
      this.loading = true;
      const opt = { query: this.search };
      getShangPin(opt)
        .then((data) => {
          if (data.status === "SUCCESSED") this.products = data.data;
        })
        .finally(() => (this.loading = false));
    },
    min_jiage(item) {
      let min = item.sku.length > 0 ? item.sku[0].jiage : 0;
      for (let i = 0, len = item.sku.length; i < len; i += 1) {
        if (item.sku[i].jiage < min) min = item.sku[i].jiage;
      }
      return min;
    },
  },
};
</script>
